import { getType } from 'typesafe-actions';
import * as actions from '../actions';
import { initEntityState, entityLoadingStarted, entityLoadingSucceeded, entityLoadingFailed } from '../utils';

export const defaultState = {
  authorList: initEntityState(null),
  currentAuthor: initEntityState(null)
};

const states = (state = defaultState, action) => {
  switch (action.type) {
    
    case getType(actions.getAuthorList.request):
      return { ...state, authorList: entityLoadingStarted(state.authorList, action.payload) };
    case getType(actions.getAuthorList.success):
      return { ...state, authorList: entityLoadingSucceeded(state.authorList, action.payload) };
    case getType(actions.getAuthorList.failure):
      return { ...state, authorList: entityLoadingFailed(state.authorList) };

      case getType(actions.getCurrentAuthor.request):
      return { ...state, currentAuthor: entityLoadingStarted(state.currentAuthor, action.payload) };
    case getType(actions.getCurrentAuthor.success):
      return { ...state, currentAuthor: entityLoadingSucceeded(state.currentAuthor, action.payload) };
    case getType(actions.getCurrentAuthor.failure):
      return { ...state, currentAuthor: entityLoadingFailed(state.currentAuthor) };
    

    default:
      return state;
  }
};

export default states;
